import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'Components/UI/FacetRouter/FacetRouter';
import EventContent from './EventContent';


const EventTypeAnnual = 'annual';
const EventTypeIntro = 'intro';
const EventTypeCheckIn = 'check-in';
const EventTypeFactFinding = 'fact-finding';
const EventTypeDiscovery = 'discovery';
const EventTypeLetsGo = 'lets-go';
const EventTypePlanning = 'planning';
const EventTypeService = 'service';
const EventTypeUncategorized = 'un-categorized';

const blueTheme = {
  border: {
    borderColor: '#195a7c',
  },
  color: {
    color: '#195a7c',
  },
};

const greenTheme = {
  border: {
    borderColor: '#38987b',
  },
  color: {
    color: '#38987b',
  },
};

const orangeTheme = {
  border: {
    borderColor: '#f7901e',
  },
  color: {
    color: '#f7901e',
  },
};

const lightBlueTheme = {
  border: {
    borderColor: '#53b4e5',
  },
  color: {
    color: '#53b4e5',
  },
};

const greyTheme = {
  border: {
    borderColor: '#898989',
  },
  color: {
    color: '#898989',
  },
};

const eventTypeColorMap = {
  [EventTypeAnnual]: blueTheme,
  [EventTypeIntro]: blueTheme,
  [EventTypeCheckIn]: greenTheme,
  [EventTypeFactFinding]: blueTheme,
  [EventTypeDiscovery]: blueTheme,
  [EventTypeLetsGo]: orangeTheme,
  [EventTypePlanning]: lightBlueTheme,
  [EventTypeService]: lightBlueTheme,
  [EventTypeUncategorized]: greyTheme,
};

const eventTypeLabelMap = {
  [EventTypeAnnual]: 'Annual',
  [EventTypeIntro]: 'Intro',
  [EventTypeCheckIn]: 'Check-in',
  [EventTypeFactFinding]: 'Fact Finding',
  [EventTypeDiscovery]: 'Proposal',
  [EventTypeLetsGo]: "Let's Go",
  [EventTypePlanning]: 'Planning',
  [EventTypeService]: 'Planning',
  [EventTypeUncategorized]: 'Planning',
};

const allEventTypes = [
  EventTypeAnnual,
  EventTypeIntro,
  EventTypeCheckIn,
  EventTypeFactFinding,
  EventTypeDiscovery,
  EventTypeLetsGo,
  EventTypePlanning,
  EventTypeService,
  EventTypeUncategorized,
];

const coalesceType = (meetingType) => {
  if (allEventTypes.includes(meetingType)) {
    return meetingType;
  }
  return EventTypeUncategorized;
};

const WeeklyCalendarEvent = ({
  meetingType,
  title,
  startTime,
  endTime,
  bestNextSteps,
  householdId,
  missionControlURL,
  status,
}) => {
  const coalescedMeetingType = coalesceType(meetingType);
  const { border } = eventTypeColorMap[coalescedMeetingType];
  const meetingTypeLabel = eventTypeLabelMap[coalescedMeetingType];
  const meetingTitleWithHouseholdId = `${title} (${householdId})`;
  const meetingTimeRange = `${moment(startTime).format('h:mm')} - ${moment(endTime).format('h:mm')}`;

  return status === 'accepted' ? (
    <Link to={missionControlURL}>
      <EventContent
        meetingTypeLabel={meetingTypeLabel}
        eventTitle={meetingTitleWithHouseholdId}
        timeRange={meetingTimeRange}
        border={border}
        bestNextSteps={bestNextSteps}
        status={status}
      />
    </Link>
  ) : (
    <EventContent
      meetingTypeLabel={meetingTypeLabel}
      eventTitle={meetingTitleWithHouseholdId}
      timeRange={meetingTimeRange}
      border={border}
      bestNextSteps={bestNextSteps}
      status={status}
    />
  );
};

WeeklyCalendarEvent.propTypes = {
  meetingType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  bestNextSteps: PropTypes.array.isRequired,
  householdId: PropTypes.string.isRequired,
  missionControlURL: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};

export default WeeklyCalendarEvent;
